import PetitionerError from './PetitionerError';
class InvalidPetitionerId extends PetitionerError {
    petitionerId;
    constructor(petitionerId, options) {
        super('Petitioner id is invalid', options);
        this.petitionerId = petitionerId;
    }
}
export default InvalidPetitionerId;
